import { DialogActions as ExoDialogActions } from "@exopengithub/exokit";
import type { ComponentProps } from "react";
import { useTranslation } from "react-i18next";

// Portal wrapper: injects the Swedish default cancel label.
export const DialogActions = (
	props: ComponentProps<typeof ExoDialogActions>,
) => {
	const { t } = useTranslation();
	return <ExoDialogActions cancelLabel={t("Cancel")} {...props} />;
};
